import React from "react";
import { FIELD_RENDERERS } from "./fields";
import { POINTS_ADMIN } from "../../config/lang";
import { translate } from "../../util/util";

function renderField(field, { item, errors, onChange, lang, labels, G }) {
  const Renderer = FIELD_RENDERERS[field.type];
  if (!Renderer) return null;
  const _label = translate(G, field.label, lang) || field.label;
  return (
    <div key={field.name} className={field.wide ? "pt-form-cell-wide" : undefined}>
      <Renderer
        field={{ ...field, _label }}
        value={item[field.name]}
        item={item}
        lang={lang}
        labels={labels}
        onChange={onChange}
        error={errors[field.name]}
      />
      {errors[field.name] && <div className="pt-field-error">{errors[field.name]}</div>}
    </div>
  );
}

export default function ResourceForm({ descriptor, item, errors = {}, onChange, lang }) {
  const G = POINTS_ADMIN;
  const labels = {
    lat: translate(G, "f_lat", lang),
    lng: translate(G, "f_lng", lang),
    removeImage: translate(G, "remove_image", lang),
    crop: translate(G, "crop_confirm", lang),
    cropConfirm: translate(G, "crop_confirm", lang),
    cropCancel: translate(G, "crop_cancel", lang),
  };
  const ctx = { item, errors, onChange, lang, labels, G };

  if (Array.isArray(descriptor.sections) && descriptor.sections.length) {
    const fieldsByName = {};
    descriptor.fields.forEach(field => { fieldsByName[field.name] = field; });

    return (
      <div className="mp-edit">
        {descriptor.sections.map(section => (
          <div className="pt-form-section" key={section.title}>
            <h3 className="pt-form-section-title">{translate(G, section.title, lang) || section.title}</h3>
            <div className="mp-edit-grid">
              {section.fields
                .map(name => fieldsByName[name])
                .filter(Boolean)
                .map(field => renderField(field, ctx))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="mp-edit">
      <div className="mp-edit-grid">
        {descriptor.fields.map(field => renderField(field, ctx))}
      </div>
    </div>
  );
}
